import { VerifyEmailForm } from '../../component/account/verify-email-form'
import React from 'react'

export const VerifyEmailScreen = (): React.ReactElement => (
  <div className="floating-form">
    <VerifyEmailForm />
  </div>
)
